export const collectionNames = {
  INVALID_MAGIC_EDEN_SLUG: 'invalid_magic_eden_slug',
  TOP_COLLECTIONS: 'top_collections',
  DISCORD_SERVERS: 'discord_servers',
  FLOOR_PRICE_HISTORY: 'floor_price_history',
  THREAD_MESSAGES: 'thread_messages',
  USERS: 'users',
  NEWS_ARTICLES: 'news_articles',
  PROJECT_ANNOUNCEMENTS: 'project_announcements',
  REQUEST_NEW_NFT_COLLECTION: 'request_nft_collections',
  FLAGGED_COLLECTION: 'flagged_collections',
  COLLECTION_LISTINGS: 'collection_listings',
  USER_FEEDBACK: 'user_feedback',
  SCHEDULER_CONFIG: 'scheduler_config',
}

export const orderRef = {
  CREATED_AT: 'created_at',
  SCRAPED_AT: 'scraped_at',
  MARKET_CAP: 'stats.market_cap',
}

export const order = {
  ASC: 'asc',
  DESC: 'desc',
}
